import { FC } from 'react'
import { RefundProps } from '@/root/shared-types'
import cn from 'classnames'
import { RefundRouteInfo } from '@/root/modules/tuuleliinid/RefundCard/components/RefundRouteInfo/RefundRouteInfo'
import { RefundAmountInfo } from '@/root/modules/tuuleliinid/RefundCard/components/RefundAmountInfo/RefundAmountInfo'
import { RefundAgreement } from '@/root/modules/tuuleliinid/RefundCard/components/RefundAgreement/RefundAgreement'
import { Divider } from '@/root/ui/tuuleliinid/Divider/Divider'
import { BottomNavButtons } from '@/root/components/tuuleliinid'
import { useGetTranslations, useIsMobile } from '@/root/shared-hooks'

export const RefundCard: FC<RefundProps> = ({
  refundRouteInfoPropsThere,
  refundRouteInfoPropsBack,
  refundAmountInfoProps,
  refundAgreementProps,
  actionButtonProps,
  isRoundTrip,
}) => {
  const isMobile = useIsMobile(480)
  const { getTranslation } = useGetTranslations()

  const { onKeepTickets, onCancel, canConfirm, isCancellationInProgress } = actionButtonProps

  return (
    <>
      <div className="rounded-xl bg-white p-4">
        <div className={cn('flex flex-col gap-2 md:grid md:grid-cols-2', isRoundTrip && 'md:grid-cols-[1fr_40px_1fr]')}>
          <div>
            <RefundRouteInfo {...refundRouteInfoPropsThere} />
          </div>
          {isRoundTrip && (
            <>
              <Divider color="primary-base" vertical={!isMobile} />
              <RefundRouteInfo {...refundRouteInfoPropsBack} />
            </>
          )}
        </div>
        <div className="max-w-content relative mx-auto my-8 flex h-max w-full items-center justify-start">
          <div className="h-px w-full border-t-3 border-dotted" />
        </div>
        <div className="flex flex-col gap-6 md:grid md:grid-cols-2 md:gap-10">
          <RefundAmountInfo {...refundAmountInfoProps} />
          <RefundAgreement {...refundAgreementProps} />
        </div>
      </div>
      {/* Bottom navigation */}
      <BottomNavButtons
        className="my-10"
        backTitle={getTranslation('buttonCancel')}
        backSubtitle={getTranslation('buttonCancelSubtitle')}
        nextTitle={getTranslation('buttonRefundContinue')}
        nextSubtitle={getTranslation(isCancellationInProgress ? 'buttonProcessing' : 'buttonRefundContinueSubtitle')}
        nextDisabled={!canConfirm}
        nextLoading={isCancellationInProgress}
        onBack={onKeepTickets}
        onNext={onCancel}
      />
    </>
  )
}

export default RefundCard
